import _ from 'lodash'
import jwt from 'jsonwebtoken'
import { constants } from '../constants'
import moment from 'moment'
import { Modal } from 'antd'
import UAParser from 'ua-parser-js';
import axios from 'axios';

const OS_TYPES = {
  MAC_OS: 'Mac OS',
  IOS: 'iOS',
  WINDOWS: 'WINDOWS',
  ANDROID: 'ANDROID',
}

class Util {
  getObj = (collection, id) => _.find(collection, { _id: id })

  getDateString = (date) => moment(date).startOf('day').format('MM-DD-YYYY')

  getCopyrightText = () =>
    constants.COPYRIGHT.TEXT(moment().format(constants.YEAR_TAG))

  // DECODE ONLY — never verify the signature here.
  //
  // This used to call jwt.verify(token, constants.SECRET), which required the
  // server's JWT SIGNING SECRET to be hardcoded in constants.js and therefore
  // shipped in the browser bundle. Anyone could read it out of main.*.js and
  // forge a token for any _id and any role, including SUPER_ADMIN — a complete
  // authentication bypass. See docs/BUGS.md.
  //
  // The browser cannot hold a secret, so client-side verification buys nothing:
  // the API verifies every request server-side, which is the only check that
  // counts. Here the token is used purely for routing and UI state, so decoding
  // is sufficient. The expiry check is kept explicitly, since jwt.decode (unlike
  // jwt.verify) does not enforce `exp`.
  //
  // Side effect of removing the shared secret: the server's SECRET no longer has
  // to match a value baked into this bundle, so each environment can use its own
  // strong random SECRET (prod2 does).
  verifyToken = (token, returndecoded = false) => {
    try {
      if (token == null || token == undefined) return null
      const decoded = jwt.decode(token)
      if (!decoded) return undefined
      // exp is in SECONDS; Date.now() is milliseconds.
      if (decoded.exp && decoded.exp * 1000 < Date.now()) return undefined
      return returndecoded ? decoded : token
    } catch (err) {
      console.log('decode error', err.message)
    }
  }

  filterRows = (Rows, keys, selected) => {
    let data = []
    let rows = selected.row ? selected.row.concat(Rows) : Rows
    keys.forEach((e, i) => {
      let row = _.find(rows, { key: e })
      row && data.push(row)
    })
    return data
  }

  generateRandomString = (length) => {
    var result = ''
    var characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789'
    var charactersLength = characters.length
    for (var i = 0; i < length; i++) {
      result += characters.charAt(Math.floor(Math.random() * charactersLength))
    }
    return result
  }

  getBase64 = (img, callback) => {
    const reader = new FileReader()
    reader.addEventListener('load', () => callback(reader.result))
    reader.readAsDataURL(img)
  }

  isSame = (date, datetocompare) => {
    var dateToCompare = moment(datetocompare)
    var mDate = moment(date)
    return dateToCompare.startOf('day').isSame(mDate.startOf('day'))
  }

  isAfter = (date, datetocompare) => {
    var dateToCompare = moment(datetocompare)
    var mDate = moment(date)
    return dateToCompare.startOf('day').isAfter(mDate.startOf('day'))
  }

  intervalOptions = (index = 1) => {
    return _.find(constants.INTERVAL_OPTIONS, { index: parseInt(index) }).name
  }

  getOS() {
    var userAgent = window.navigator.userAgent,
      platform = window.navigator.platform,
      macosPlatforms = ['Macintosh', 'MacIntel', 'MacPPC', 'Mac68K'],
      windowsPlatforms = ['Win32', 'Win64', 'Windows', 'WinCE'],
      iosPlatforms = ['iPhone', 'iPad', 'iPod'],
      os = null

    if (macosPlatforms.indexOf(platform) !== -1) {
      os = OS_TYPES.MAC_OS
    } else if (iosPlatforms.indexOf(platform) !== -1) {
      os = OS_TYPES.IOS
    } else if (windowsPlatforms.indexOf(platform) !== -1) {
      os = OS_TYPES.WINDOWS
    } else if (/Android/.test(userAgent)) {
      os = OS_TYPES.ANDROID
    } else if (!os && /Linux/.test(platform)) {
      os = 'Linux'
    }
    return os
  }

  getDate = (date, number) => {
    var dateObj = moment(date.toUTCString())
    dateObj.add(number, 'days')
    return dateObj.toDate()
  }

  /**
   * The time-zone offset is the difference, in minutes, between UTC and local time.
   * Note that this means that the offset is positive if the local timezone is behind UTC and negative if it is ahead.
   * For example, if your time zone is UTC+10 (Australian Eastern Standard Time), -600 will be returned.
   * Daylight savings time prevents this value from being a constant even for a given locale
   */
  //https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Intl/DateTimeFormat/DateTimeFormat

  getTimeZone = () => {
    let tz = Intl.DateTimeFormat().resolvedOptions().timeZone
    if (tz == null || tz == undefined) {
      tz = moment.tz.guess() || 'America/Chicago'
    }
    return tz
  }
  /**
   * Get or set the UTC offset in minutes.
   * Note: Unlike moment.fn.zone this function returns the real offset from UTC,
   * not the reverse offset (as returned by Date.prototype.getTimezoneOffset).
   */
  getTimeZoneOffsetInHour = () => {
    return moment().utcOffset() / 60
  }

  convertRoleToNumber = (role) => {
    try {
      if (role) return parseInt(role)
      return role
    } catch (error) {
      console.log(error, 'Error in convertRoleToNumber')
      return role
    }
  }
  
  toNumber = (data) => {
    try {
      if (data && typeof data === 'string') 
        return parseInt(data)
    } catch (error) {
      console.log(error, 'Error in toNumber')
    }
    return data
  }

  getCookie = (name) => {
    const cookies = document.cookie.split(';');
    for (let cookie of cookies) {
      const [cookieName, cookieValue] = cookie.trim().split('=');
      if (cookieName === name) {
        return decodeURIComponent(cookieValue);
      }
    }
    return null;
  };

getLocation = () => {
  return new Promise((resolve, reject) => {
    if (!navigator.geolocation) {
      return reject('Geolocation not supported');
    }

    navigator.geolocation.getCurrentPosition(
      async(position) => {
        const lat = position.coords.latitude;
        const lon = position.coords.longitude;
        const response =  await axios.get(`https://nominatim.openstreetmap.org/reverse?format=json&lat=${lat}&lon=${lon}`);
        const data =response.data;
        console.log(data,"dataaa")
              const location = {
          city: data.address.city || data.address.town || data.address.village,
          state: data.address.state,
          country: data.address.country,
          continent: data.address.continent ,
          display_name:data.display_name,
        };

        resolve(location);
      },
      (error) => {
        reject(error.message);
      }
    );
  });
}; 

getDeviceInfo = () => {
  const parser = new UAParser();
  const result = parser.getResult();

  const deviceInfo = {
    browser: result.browser.name + ' ' + result.browser.version,
    os: result.os.name + ' ' + result.os.version,
    model: result.device.model,
    type: result.device.type ,
    info:result.ua,
  };

  return deviceInfo;
};
}

export { OS_TYPES }
export default new Util()
